import { memo } from "react";
import { Navigate, generatePath } from "react-router";

import { PATHS } from "@/routes/paths";

import * as Repository from "@/components/features/_shared/repository/hotel-application-data";

import { CancellationPresenter } from "./presenter";

type Props = {
	hotelID: string;
};

export const CancellationContainer = memo(({ hotelID }: Props) => {
	const { hotelApplicationData } = Repository.Query.useHotelApplicationDataQuery(hotelID);

	if (!hotelApplicationData) {
		return <Navigate to={generatePath(PATHS.HOTEL.TOP, { hotelID })} />;
	}

	return <CancellationPresenter hotelApplicationData={hotelApplicationData} />;
});
